import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { getThirdPartyUserSubServicesHistoryActions } from "../getThirdPartyUserSubServicesHistory/getThirdPartyUserSubServicesHistory";

export type DeleteUserSubServiceLoadAction = {
  type: string;
  payload: { id: number | string | null };
};

export type DeleteUserSubServiceData = {};

const DeleteUserSubService = new ReduxFetchState<
  DeleteUserSubServiceData | null,
  { id: number | string | null },
  any
>("deleteUserSubService");

export function* watchDeleteUserSubService(
  action: DeleteUserSubServiceLoadAction,
) {
  try {
    const { id } = action.payload;
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: DeleteUserSubServiceData = yield axios({
      url: `/api/v1/ai/user-sub-service/${id}`,
      method: "DELETE",
      headers: {
        lang,
      },
    });

    yield put(DeleteUserSubService.actions.loadSuccess());
    yield put(getThirdPartyUserSubServicesHistoryActions.load());
  } catch (e: any) {
    yield put(DeleteUserSubService.actions.loadFailure(e?.response?.data));
  }
}

export function* deleteUserSubServiceSagas() {
  yield takeEvery(
    DeleteUserSubService.actionTypes.load,
    watchDeleteUserSubService,
  );
}

export function useDeleteUserSubService() {
  const { loading, data, ...deleteUserSubServiceState } = useAppSelector(
    (state) => state.deleteUserSubService,
  );
  const dispatch = useAppDispatch();

  const dispatchDeleteUserSubService = useCallback(
    (data: { id: number | string | null }) => {
      dispatch(DeleteUserSubService.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...deleteUserSubServiceState,
    dispatchDeleteUserSubService,
    deleteUserSubServiceLoading: loading,
    deleteUserSubServiceData: data,
  };
}

export const {
  actionTypes: deleteUserSubServiceActionsTypes,
  actions: deleteUserSubServiceActions,
  reducer: deleteUserSubServiceReducer,
} = DeleteUserSubService;
